import { getResource } from "./rest-helper";
const namespace = "pins";
const api = {
  getCollection: getResource(namespace).getCollection,
};
export { api as default };
